import { atom } from 'recoil';

export const ismodalNewLocationOpenAtom = atom<boolean>({
  key: 'isNewLocationModalOpenState',
  default: false,
});
